import { connect } from 'react-redux';
import { OutboundSuccess } from '../shared/OutboundSuccess';
import { getOutbound, downloadOutboundReceipt } from '../../app/store/actions/imsAdminActions';

const AdminOutboundSuccess = (props) => (
    <OutboundSuccess
        {...props}
        roleBasePath="/ims/admin"
    />
);

const mapStateToProps = (state) => ({
    outbound: state?.records?.outbound,
    isLoading: state?.records?.isLoading || state?.wait?.isLoading,
});

export default connect(mapStateToProps, { getOutbound, downloadOutboundReceipt })(AdminOutboundSuccess);
